import { Component, OnInit } from '@angular/core';
import { ParamMap, Router, ActivatedRoute, RoutesRecognized } from '@angular/router';
import { trigger, state, style, animate, transition } from '@angular/animations';
import { AuthService } from 'src/app/core/helpers/auth.service';
import { Location } from '@angular/common';
import { filter, pairwise } from 'rxjs/operators';


@Component({
  selector: 'loyaltic-dev-navigation',
  templateUrl: './dev-navigation.component.html',
  styleUrls: ['./dev-navigation.component.scss'],

  animations: [
    trigger('fadeSlideInOut', [
      transition(':enter', [
        style({ opacity: 0, transform: 'translateY(20px)' }),
        animate('500ms', style({ opacity: 1, transform: 'translateY(0)', })),
      ]),
      // transition(':leave', [
      //   animate('300ms', style({ opacity: 0, transform: 'translateY(-20px)' })),
      // ]),

    ]),


    trigger('slideInLeft', [
      transition(':enter', [
        style({ opacity: 0, transform: 'translateX(100px)' }),
        animate('500ms', 
        style({ opacity: 1, transform: 'translateX(0)', })),
      ]),
      // transition(':leave', [
      //   animate('400ms',
      //   style({ opacity: 0, transform: 'translateX(-100px)' })),
      // ]),
    ]),
    
  ]
})
export class DevNavigationComponent implements OnInit {
  isShowProfile = false;
  isShowRegister = true;
  isShowLogin = false;
  isShowRewardsList = false;
  isLoggedIn = false;
  userId: any;
  queryParam = '';
  checkUrl = '';
  
  constructor(private authService: AuthService, private router: Router, private route: ActivatedRoute, private location: Location) {
    this.userId = authService.getUserId();
   }

  ngOnInit() {
    if(this.userId){
      this.isLoggedIn = true;
      this.showProfile();
    }
    // this.router.events.pipe( filter((evt:any)=>evt instanceof RoutesRecognized),pairwise())
    // .subscribe((events: RoutesRecognized[]) =>{        
    //     console.log('previous',events[0].urlAfterRedirects);//previous url
    //     console.log('current url',events[1].urlAfterRedirects);//current url
    //     this.checkUrl = events[0].urlAfterRedirects;
    //     if(this.checkUrl == '/login'){
    //       this.router.navigate(['']);
    //       return false;
    //     }
    //   } );  
  }
  showProfile(){
    this.resetSelectedOption();
    this.isShowProfile = true;
  }
  showRegister(){
    this.resetSelectedOption();
    this.isShowRegister = true;
  }
  showLogin(){
    this.resetSelectedOption();
    this.isShowLogin = true;
  }
  showRewardsList(){
    this.resetSelectedOption();
    this.isShowRewardsList = true;
  }

  resetSelectedOption() {
    this.isShowProfile = false;
    this.isShowRegister = false;
    this.isShowLogin = false;
    this.isShowRewardsList = false;
  }
}
